module.exports = __webpack_public_path__ + "assets/img/telegram.65c968a2.webp";